import React from 'react';
import AdminDashboard from '../../UserPanel/Shared/AdminDashboard/AdminDashboard';
import img from '../../Assets/adminHome.jpg'

const Admin = () => {
    return (
        <div>
            <AdminDashboard></AdminDashboard>
            <img style={{ 'width': '100%' }} src={img} alt="" />

        </div>
    );
};

export default Admin;